<template>
  <Cfg>
    <slot>
      <div class="animated fadeIn">
        <Alerts ref="alert"/>
        <Forms ref="frmGroup"
          :title="this.$lang.Branch.TitleForm"
          :showHelp="true"
          :showClearButton="true"
          :showSaveButton="true"
          v-on:Clear="onClear"
          v-on:Save="onSave">
          <div class="form-group row">
            <div class="col-md-6">
              <label for="txtBranchName"><small class="text-danger">*</small> {{$lang.Branch.LabelName}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              name="txtBranchName"
                              :placeholder="$lang.Branch.PlaceholderEnterName"
                              v-model="form.name.value"
                              :size="form.name.maxlength"
                              :required="form.name.required"
                              :state="form.name.state"></b-form-input>
              </div>
            </div>
            <div class="col-md-6">
              <label for="txtCNPJ"><small class="text-danger">*</small> {{$lang.Branch.LabelCNPJ}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              id="txtCNPJ"
                              name="txtCNPJ"
                              :placeholder="$lang.Branch.PlaceholderEnterCNPJ"
                              v-model="form.cnpj.value"
                              :size="form.cnpj.maxlength"
                              :required="form.cnpj.required"
                              :state="form.cnpj.state"
                              v-mask="['##.###.###/###-##','###.###.###/###-##']"></b-form-input>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <label for="txtDescription"> {{$lang.Branch.LabelDescription}}:</label>
              <b-form-textarea id="txtDescription"
                          name="txtDescription"
                          v-model.trim="form.description.value"
                          :placeholder="$lang.Branch.PlaceholderEnterDescription"
                          :rows="form.description.rows"
                          :size="form.description.maxlength"
                          :noResize="form.description.noResize"></b-form-textarea>
              <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
            </div>
          </div>
        </Forms>

        <Tables ref="tableGrid"
            :columns="[$lang.Branch.DataTable.Name,
                       $lang.Branch.DataTable.CNPJ,
                       $lang.Common.DataTable.Status,
                       $lang.Common.DataTable.ActionDate,
                       $lang.Common.DataTable.AccountAction,
                       $lang.Common.DataTable.Actions]"
            :showSearch="true"
            :showPrint="true"
            :showDownload="true"
            :showFullscreen="true"
            v-on:Load="onLoad">
          <tr v-for="obj in this.objList" v-bind:key="obj.id">
            <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.name" />
            <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.cnpj" />
            <TableColumn :IsStatus="true"   v-on:Edit="onEdit(obj)" :status="obj.status" />
            <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateUpdate" />
            <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.accountUserNameUpdate" />
            <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
          </tr>
        </Tables>
      </div>
    </slot>
  </Cfg>
</template>

<script>
import Branch from './branch.js'

export default Branch
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/branch/branch.vue